import { NextSeo } from 'next-seo';

//screens
import { WarehouseCustomerService } from '@/screens/Agents/WarehouseCustomerService';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function WarehouseCustomerServicePage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/warehouse-customer-service/"
        title="Warehouse Customer Service Agent | Loadsmart AI"
        description="Answers the emails your warehouse gets all day about arrivals, receipts and ship dates. Opendock answers the appointment side and your WMS answers the inventory side. It books or moves appointments in Opendock and hands exceptions to a rep."
        openGraph={{
          url: 'https://loadsmart.com/ai/warehouse-customer-service/',
          images: [
            {
              url: `${process.env.SITE_URL}/images/share/ai/warehouse-customer-service.png`,
              width: 1200,
              height: 630,
              alt: 'Warehouse Customer Service Agent',
              type: 'image/png',
            },
          ],
        }}
      />
      <JsonLd data={Organization} />
      <WarehouseCustomerService />
    </>
  );
}
